import { render, staticRenderFns } from "./personnalInfo.vue?vue&type=template&id=22ccc95e"
import script from "./personnalInfo.vue?vue&type=script&lang=js"
export * from "./personnalInfo.vue?vue&type=script&lang=js"
import style0 from "./personnalInfo.vue?vue&type=style&index=0&id=22ccc95e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports